import {
    userRightsPostProcessingMiddleware,
    userRightsPreProcessingBodyMiddleware,
} from '../../../../helpers/userRightsMiddlewares';

import { QueryClient } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { UserRightT } from 'business/definitions';

/**
 * Updates the user rights of one user.
 * @param {number} userId - The id of the user to update.
 * @param {UserRightT[]} userRights - The new user rights of the user.
 * @param {string[]} resources - The list of resources allowed to be added in the user rights.
 * @param {QueryClient} queryClient - The QueryClient instance from react-query.
 */
export const updateUserRights = async (
    userId: number,
    userRights: UserRightT[],
    resources: string[],
    queryClient: QueryClient,
) => {
    const response = await RQAPICallWithData<Record<string, UserRightT[]>>({
        body: userRights?.filter((userRight) =>
            resources.includes(userRight.resourceType),
        ),
        endpoint: `user_rights/${userId}`,
        method: 'PUT',
        postProcessingCallback: userRightsPostProcessingMiddleware,
        preProcessingBodyCallback: (body: UserRightT[]) =>
            userRightsPreProcessingBodyMiddleware(body),
    });
    queryClient.setQueryData(
        ['users_user_rights'],
        (oldUsersUserRights: Record<string, UserRightT[]>) => ({
            ...oldUsersUserRights,
            ...response.content.data,
        }),
    );
    queryClient.setQueryData(
        ['user_rights', userId],
        () => response.content.data,
    );
};
